import React from 'react';
import { Caption2 } from '../../../../../components/Font';
import { FormDateContainer } from '../styles';
import { DatePicker } from '../../../../../ui/FormDatePicker/DatePickerSelectors';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';
import { IRegisterForm } from '../../../../../interface/Auth/frontend';
import { useAppSelector } from '../../../../../app/hooks';

interface IProps {
	registerForm: IRegisterForm;
	setRegisterForm(value: IRegisterForm): void;
}

export const RegFormDate: React.FC<IProps> = ({ registerForm, setRegisterForm }) => {
	const { error } = useAppSelector(state => state.auth);
	const { t } = useTranslation();
	const Theme = useTheme();

	return (
		<>
			<Caption2 style={{ textAlign: 'start', width: '100%', margin: '20px 0 8px' }} color={Theme.color.secondary}>
				{t('passport.registrationForm.birthdateForm.title')}
			</Caption2>

			<FormDateContainer>
				<DatePicker
					maxDate={moment().subtract(113, 'year')}
					error={error['birth_date']}
					initDate={registerForm.birthDate ? moment(registerForm.birthDate) : null}
					onChange={date => {
						setRegisterForm({ ...registerForm, birthDate: moment(date).toISOString(true) });
					}}
				/>
			</FormDateContainer>
		</>
	);
};
